/* template */
<template minapp="mpx" xlang="wxml"><es-drawer-bottom title="退票详情" :show="(show)" showDefaultNav @close="closeRefundDetail" :navbarStyle="(curNavBarStyle)" :customStyle="(curCustomStyle)" class="main"><div class="list-content" v-if="(refundDetail)"><div class="normal-item"><div class="left">退票人</div><div class="right">{{refundDetail.passenger_name}}</div></div><div class="normal-item"><div class="left">退票行程</div><div class="right-flight"><div class="right-city"><div>{{refundDetail.from_station_name}}</div><es-icon name="arrow-switch-right" size="13" class="city-arrow"/><div>{{refundDetail.to_station_name}}</div></div><div class="train-time">{{refundTicketTime}}</div></div></div><div class="normal-item"><div class="left">退票原因</div><div class="right">{{refundDetail.reason}}</div></div><div class="normal-item"><div class="left">退票时间</div><div class="right">{{refundTime}}</div></div></div></es-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m410c8328"}'>
  @import '~@/mixins/stylus/color.styl'

  .main
    /deep/ .es-navbar
      background-color $train-color-background
    /deep/ .drawer-container
      overflow auto
  .list-content
    margin 10px 12px
    padding 17px 12px
    background-color #ffffff
    border-radius 8px
    display flex
    flex-direction column
  .normal-item
    display flex
    margin-bottom 12px
    justify-content flex-start
    align-items flex-start
  .left
    flex 0 0 73px
    color $train-color-light-gray
    font-size 14px
    // white-space nowrap
  .right
    flex 1
    color $train-color-dark-gray
    font-size 14px
    line-height 20px
  .right-flight
    display flex
    flex-direction column
  .right-city
    display flex
    font-size 14px
  .city-arrow
    margin-left 4px
    margin-right 4px
    margin-top 4px
  .train-time
    color $train-color-light-gray
    font-size 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m410c8328"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./refund-detail-info-alert.mpx.js?isComponent&outputPath=components%2Frefund-detail-info-alert410c8328%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./refund-detail-info-alert.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Frefund-detail-info-alert410c8328%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m410c8328"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/refund-detail-info-alert410c8328/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-drawer-bottom':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
